import { render, staticRenderFns } from "./answer-questions4.vue?vue&type=template&id=c13d5a46&scoped=true&"
import script from "./answer-questions4.vue?vue&type=script&lang=js&"
export * from "./answer-questions4.vue?vue&type=script&lang=js&"
import style0 from "./answer-questions4.vue?vue&type=style&index=0&id=c13d5a46&lang=scss&scoped=true&"
import style1 from "./answer-questions4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13d5a46",
  null
  
)

export default component.exports